const archive = document.querySelector('body.post-type-archive-uttalelser');

if(archive) {
  let selectedCaseType = new URLSearchParams(document.location.search).get('case_type') || '';
  let selectedSubCaseType = new URLSearchParams(document.location.search).get('sub_case_type') || '';
  let selectedYear = new URLSearchParams(document.location.search).get('period') || '';
  let currentPage = parseInt(new URLSearchParams(document.location.search).get('page')) || 1;

  // SEARCH
  const searchForm = archive.querySelector('.filter-form');
  const inputField = searchForm.querySelector('input');
  const submitBtn = searchForm.querySelector('button');

  searchForm.addEventListener('submit', function(e) {
    e.preventDefault();
    e.stopPropagation();
  });

  inputField.addEventListener('search', function(e) {
    updatePage();
  });

  submitBtn.addEventListener('click', function(e) {
    e.preventDefault();
    updatePage();
  });

  if(archive.querySelector('.filter-group.period .select-options li a.selected')) {
    archive.querySelector('.filter-group.period .active-input span').innerHTML = archive.querySelector('.filter-group.period .select-options li a.selected').getAttribute('data-name');
  }

  if(archive.querySelector('.filter-group.case_type .select-options li a.selected')) {
    archive.querySelector('.filter-group.case_type .active-input span').innerHTML = archive.querySelector('.filter-group.case_type .select-options li a.selected').getAttribute('data-name');
  }

  // FILTER
  const caseTypeSelect = archive.querySelector('.filter-group.case_type .active-input');
  caseTypeSelect.addEventListener('click', function(e) {
    e.preventDefault();
    if(!this.classList.contains('open')) {
      $(this.closest('.select-input').querySelector('.select-options')).slideDown(500);
      this.querySelector('button').setAttribute('aria-expanded', 'true');
      this.classList.add('open');
      if(window.innerWidth >= 768) {
        document.querySelector('body').classList.add('no-scroll');
        $('html, body').animate({
          scrollTop: $(this).offset().top - 100
        }, 300);
      }
    }
    else {
      $(this.closest('.select-input').querySelector('.select-options')).slideUp(500);
      this.classList.remove('open');
      this.querySelector('button').setAttribute('aria-expanded', 'false');
      document.querySelector('body').classList.remove('no-scroll');
    }
  });

  const caseTypeOptions = archive.querySelectorAll('.filter-group.case_type .select-options li a');
  caseTypeOptions.forEach(function(link) {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      selectedCaseType = this.getAttribute('data-value');
      selectedSubCaseType = '';
      updatePage();
    });
  });

  const yearSelect = archive.querySelector('.filter-group.period .active-input');
  yearSelect.addEventListener('click', function(e) {
    e.preventDefault();
    if(!this.classList.contains('open')) {
      $(this.closest('.select-input').querySelector('.select-options')).slideDown(500);
      this.classList.add('open');
      this.querySelector('button').setAttribute('aria-expanded', 'true');
      if(window.innerWidth >= 768) {
        document.querySelector('body').classList.add('no-scroll');
        $('html, body').animate({
          scrollTop: $(this).offset().top - 100
        }, 300);
      }
    }
    else {
      $(this.closest('.select-input').querySelector('.select-options')).slideUp(500);
      this.classList.remove('open');
      this.querySelector('button').setAttribute('aria-expanded', 'false');
      document.querySelector('body').classList.remove('no-scroll');
    }
  });

  const yearOptions = archive.querySelectorAll('.filter-group.period .select-options li a');
  yearOptions.forEach(function(link) {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      selectedYear = this.getAttribute('data-value');
      updatePage();
    });
  });

  function updatePage() {
    currentPage = 1;
    window.location.href = window.location.pathname + '?page=' + currentPage + '&sok=' + inputField.value.toLowerCase() + '&case_type=' + selectedCaseType + '&sub_case_type=' + selectedSubCaseType + '&period=' + selectedYear;
  }


  function getCount() {
    let data = new FormData();
    data.append('action', 'get_statements_count');
    data.append('sok', inputField.value.toLowerCase());
    data.append('case_type', selectedCaseType);
    data.append('sub_case_type', selectedSubCaseType);
    data.append('period', selectedYear);

    $.ajax({
        url: sivilombudet_scripts.ajax_url,
        type: 'POST',
        data: data,
        cache: false,
        processData: false,
        contentType: false,
        dataType: 'json',
        error: function (data) {
            console.error(data);
        },
        success: function (response) {
             archive.querySelectorAll('.filter-group.period .select-options li a').forEach(function(option, index) {
              if(index < 1) {
               return; 
              }
              let type = option.getAttribute('data-type');
              if (type && response[type] != undefined) {
                 option.querySelector('.count').innerHTML = response[type];
              }
              else if(type && response.hasOwnProperty(type)) {
                option.querySelector('.count').innerHTML = '0';
              }
            });
            archive.querySelectorAll('.filter-group.case_type .select-options li a').forEach(function(option, index) {
              if(index < 1) {
               return; 
              }
              let type = option.getAttribute('data-slug');
              if (type && response[type] != undefined) {
                 option.querySelector('.count').innerHTML = response[type];
              }
              else if(type && response.hasOwnProperty(type)) {
                option.querySelector('.count').innerHTML = '0';
              }
            });
            archive.querySelectorAll('.sub-case-types ul li a').forEach(function(link, index) {
              let type = link.getAttribute('data-slug');
              if (type && response[type] != undefined) {
                 link.querySelector('.count').innerHTML = response[type] ;
              }
              else if(type && response.hasOwnProperty(type)) {
                link.querySelector('.count').innerHTML = '0';
              }
            });
        }
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    setTimeout(function() {
      getCount();
    }, 200);
  });

  window.addEventListener('click', function(e) {
    if (!e.target.closest('.active-input')) {
      archive.querySelectorAll('.active-input').forEach(function(openSelect) {
        if(openSelect.classList.contains('open')) {
          $(openSelect.closest('.select-input').querySelector('.select-options')).slideUp(500);
          openSelect.classList.remove('open');
          openSelect.querySelector('button').setAttribute('aria-expanded', 'false');
        }
      });
      document.querySelector('body').classList.remove('no-scroll');
    }
  });

}